<script lang="ts">
  import { Button } from '$lib/components/ui/button';

  export let title = 'Error';
  export let message = 'Need help?';
  export let code = 500;

  // create a query string from the title and message
  $: contactHref = `https://help.techlockdown.com?ref=members-error&title=${encodeURIComponent(
    title
  )}&message=${encodeURIComponent(message)}`;
</script>

<div class="max-w-lg">
  <div class="mb-4 flex gap-2 items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1"
      stroke="currentColor"
      class="w-8 h-8"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      />
    </svg>
    <pre>ERROR ({code})</pre>
  </div>

  <h1 class="text-2xl font-bold">{title}</h1>
  <p class="py-4">
    {message}. Try refreshing the page or contact us if the problem persists.
  </p>

  <Button variant="outline" href={contactHref}>Contact Us</Button>
</div>
